<template>
  <div class="section center">
    <div class="container-nuvem">
      <div
        v-for="(noticia, index) in noticias2"
        :key="noticia.classe"
        class="item"
        :class="noticia.classe"
        @click="openNoticias(index)"
      >
        {{ noticia.palavra }}
      </div>
    </div>
    <PopUpNoticias
      :isShowed="showNoticias"
      :noticias="noticias2"
      :index="indexNoticias"
      v-if="showNoticias"
      :show-proximo="false"
      @close="closeNoticias"
    ></PopUpNoticias>
    <div class="click-lelas mt-4">
      <i class="bi bi-hand-index mr-3"></i>
      Clique nas palavras para descobrir as manchetes.
    </div>
  </div>
</template>

<script>
import PopUpNoticias from "@/components/PopUpNoticias";
import { noticias2 } from "@/consts/noticias.js";
export default {
  components: {
    PopUpNoticias,
  },
  data() {
    return {
      indexNoticias: 0,
      showNoticias: false,
      noticias2,
    };
  },
  methods: {
    openNoticias(index) {
      this.indexNoticias = index;
      this.showNoticias = true;
    },
    closeNoticias() {
      this.showNoticias = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.section {
  min-height: 100vh;
}

.click-lelas {
  font-family: Roboto Condensed;
  font-size: 14px;
  line-height: 16px;
  color: #626262;
}

.container-nuvem {
  position: relative;
  width: 804px;
  height: 300px;

  .item {
    text-transform: uppercase;
    position: absolute;
    font-family: Roboto Condensed;
    color: #626262;
    font-size: 32px;
    line-height: 38px;
    position: absolute;
    font-style: normal;
    font-weight: normal;
    transform-origin: top left;
    cursor: pointer;
    white-space: nowrap;
  }

  .sem-ar {
    width: 100px;
    height: 38px;
    left: 0px;
    top: 124.3px;
    transform: rotate(-38.54deg);
  }

  .alojar {
    position: absolute;
    width: 135px;
    height: 49px;
    left: 45px;
    top: 293px;
    font-size: 42px;
    line-height: 49px;
    text-transform: uppercase;
    color: #626262;
    transform: rotate(-90deg);
  }

  .idosos {
    width: 117px;
    height: 45px;
    left: 8px;
    top: 210.61px;
    font-size: 38px;
    line-height: 45px;
    transform: rotate(-34.58deg);
  }

  .despedida {
    position: absolute;
    width: 120px;
    height: 30px;
    left: 96px;
    top: 262px;

    font-style: normal;
    font-weight: 400;
    font-size: 26px;
    line-height: 30px;
    text-transform: uppercase;

    color: #626262;

    transform: rotate(-90deg);
  }

  .solitarias {
    width: 153px;
    height: 38px;
    left: 130px;
    top: 218px;
    transform: rotate(-90deg);
  }

  .container {
    position: absolute;
    width: 152px;
    height: 38px;
    left: 168px;
    top: 0px;
    font-style: normal;
    font-weight: 400;
    font-size: 32px;
    line-height: 38px;
    /* identical to box height */

    text-transform: uppercase;

    color: #626262;
  }

  .estrutura-modular {
    width: 293px;
    height: 38px;
    left: 174px;
    top: 38px;
  }

  .falta-de-informacao {
    width: 284px;
    height: 35px;
    left: 173px;
    top: 77px;
    font-size: 30px;
    line-height: 35px;
  }

  .inconstitucional {
    width: 228px;
    height: 33px;
    left: 173px;
    top: 121px;
    font-size: 28px;
    line-height: 33px;
  }

  .contaminao-em-massa {
    width: 275px;
    height: 28px;
    left: 172px;
    top: 160px;
    font-size: 24px;
    line-height: 28px;
  }

  .fundacao-casa {
    width: 225px;
    height: 38px;
    left: 168px;
    top: 190px;
  }

  .adolescentes {
    width: 207px;
    height: 38px;
    left: 131px;
    top: 224px;
  }

  .um-buraco-no-coracao {
    width: 362px;
    height: 38px;
    left: 87px;
    top: 262px;
  }

  .sem-visitas {
    position: absolute;
    width: 165px;
    height: 38px;
    left: 333px;
    top: 0px;
    font-style: normal;
    font-weight: 400;
    font-size: 32px;
    line-height: 38px;
    /* identical to box height */

    text-transform: uppercase;

    color: #626262;
  }

  .sistema-prisional {
    position: absolute;
    width: 232px;
    height: 33px;
    left: 511px;
    top: 2px;

    font-style: normal;
    font-weight: 400;
    font-size: 28px;
    line-height: 33px;
    /* identical to box height */

    text-transform: uppercase;

    color: #626262;
  }

  .paises-autoritarios {
    width: 199px;
    height: 26px;
    left: 480px;
    top: 42px;
    font-size: 22px;
    line-height: 26px;
  }

  .caixoes-de-ferro {
    width: 186px;
    height: 28px;
    left: 467px;
    top: 69px;
    font-size: 24px;
    line-height: 28px;
  }

  .amor {
    width: 79px;
    height: 38px;
    left: 87px;
    top: 57.23px;
    transform: rotate(-37.62deg);
  }

  .painel-da-depen {
    width: 174px;
    height: 28px;
    left: 467px;
    top: 96px;
    font-size: 24px;
    line-height: 28px;
  }

  .refeicoes-estragadas {
    width: 244px;
    height: 28px;
    left: 403px;
    top: 125px;
    font-weight: normal;
    font-size: 24px;
    line-height: 28px;
  }

  .denuncia-tortura {
    width: 199px;
    height: 28px;
    left: 455px;
    top: 160px;
    font-size: 24px;
    line-height: 28px;
  }

  .contaminados {
    width: 216px;
    height: 38px;
    left: 411px;
    top: 190px;
  }

  .direitos-humanos {
    width: 263px;
    height: 38px;
    left: 349px;
    top: 224px;
  }

  .explicacoes {
    width: 181px;
    height: 38px;
    left: 464px;
    top: 262px;
  }

  .idosos {
    position: absolute;
    width: 98px;
    height: 38px;
    left: 686px;
    top: 144px;

    font-style: normal;
    font-weight: 400;
    font-size: 32px;
    line-height: 38px;
    /* identical to box height */

    text-transform: uppercase;

    color: #626262;

    transform: rotate(-90deg);
  }

  .amor-2 {
    position: absolute;
    width: 79px;
    height: 38px;
    left: 51px;
    top: 129.23px;

    font-style: normal;
    font-weight: 400;
    font-size: 32px;
    line-height: 38px;
    /* identical to box height */

    text-transform: uppercase;

    color: #626262;

    transform: rotate(-37.62deg);
  }

  .sem-ar-2 {
    position: absolute;
    width: 100px;
    height: 38px;
    left: 654px;
    top: 171px;

    font-style: normal;
    font-weight: 400;
    font-size: 32px;
    line-height: 38px;
    /* identical to box height */

    text-transform: uppercase;

    color: #626262;

    transform: rotate(-90deg);
  }

  .alojar-2 {
    position: absolute;
    width: 103px;
    height: 38px;
    left: 627px;
    top: 211.61px;

    font-style: normal;
    font-weight: 400;
    font-size: 32px;
    line-height: 38px;
    /* identical to box height */

    text-transform: uppercase;

    color: #626262;

    transform: rotate(-36.05deg);
  }

  .idosos-2 {
    position: absolute;
    width: 98px;
    height: 38px;
    left: 638px;
    top: 249.61px;

    font-style: normal;
    font-weight: 400;
    font-size: 32px;
    line-height: 38px;
    /* identical to box height */

    text-transform: uppercase;

    color: #626262;

    transform: rotate(-34.58deg);
  }

  .idosos-3 {
    width: 129px;
    height: 49px;
    left: 2px;
    top: 292px;
    transform: rotate(-90deg);
    font-style: normal;
    font-weight: 400;
    font-size: 42px;
    line-height: 49px;
  }

  .despedida-2 {
    width: 148px;
    height: 38px;
    left: 728px;
    top: 203px;
    transform: rotate(-90deg);
    display: none;
  }

  .temporaria {
    position: absolute;
    width: 173px;
    height: 38px;
    left: 727px;
    top: 207px;

    font-family: "Roboto Condensed";
    font-style: normal;
    font-weight: 400;
    font-size: 32px;
    line-height: 38px;
    /* identical to box height */

    text-transform: uppercase;

    color: #626262;

    transform: rotate(-90deg);
  }
}

@media screen and (max-width: 900px) {
  .container-nuvem {
    transform: scale(0.8);
  }
}

@media screen and (max-width: 700px) {
  .container-nuvem {
    transform: scale(0.7);
  }
}

@media screen and (max-width: 600px) {
  .container-nuvem {
    transform: scale(0.4);
  }
}

@media screen and (max-width: 480px) {
  .container-nuvem {
    transform: scale(0.4);
  }
}
</style>